export const rentacarPalette = {
	primary: {
		darker: '#18354a',
		dark: '#255f85',
		main: '#3388b5',
		light: '#a4cde3',
		lighter: '#e1f1f8'
	},

	secondary: {
		lighter: '#dcdcdc',
		light: '#6f6f6f',
		main: '#4b4b4b',
		dark: '#0f0f0f',
		darker: '#1e1e1e',
		contrastText: '#f9fafb'
	},

	info: {
		main: '#1890ff'
	},

	warning: {
		main: '#ffb236',
		light: '#ffe08a',
		lighter: '#fff3c2'
	},

	success: {
		light: '#a3d87c',
		lighter: '#b9e6a9'
	},

	error: {
		light: '#f28b82',
		lighter: '#f6a5a5'
	},

	background: {
		grey: '#eeeeee',
		lightGrey: '#f5f5f5'
	},

	colors: {
		red: '#ef5350',
		pink: '#ec407a',
		purple: '#ab47bc',
		deepPurple: '#7e57c2',
		indigo: '#5c6bc0',
		blue: '#42a5f5',
		lightBlue: '#29b6f6',
		cyan: '#26c6da',
		teal: '#26a69a',
		green: '#66bb6a',
		lightGreen: '#9ccc65',
		lime: '#d4e157',
		yellow: '#ffee58',
		amber: '#ffca28',
		orange: '#ffa726',
		deepOrange: '#ff7043',
		brown: '#8d6e63',
		grey: '#bdbdbd',
		blueGrey: '#78909c'
	}
}
